import React from 'react';
import { Route } from 'react-router-dom';
import { CopyDocumentsRoutes } from './Routes';

export const routes = [<Route key={0} path="/copy-documents" component={CopyDocumentsRoutes} />];

export const navigation = [{ name: 'copy_documents', link: '/copy-documents' }];
